import React, { useEffect, useState } from 'react';
import { sendPixelEvent } from '../../App';
const CHECKOUT_URL = 'https://pay.hotmart.com/O104832352I';
const PIXEL_PARAMS = {
  content_name: 'Celular bajo control, hogar en paz',
  content_type: 'product',
  value: 6.36,
  currency: 'USD'
};
const handleCheckoutClick = (e: React.MouseEvent) => {
  e.preventDefault();
  // Fire AddToCart immediately (SDK + image fallback)
  sendPixelEvent('AddToCart', PIXEL_PARAMS);
  // Fire InitiateCheckout after 300ms to ensure AddToCart is registered separately
  setTimeout(() => {
    sendPixelEvent('InitiateCheckout', PIXEL_PARAMS);
  }, 300);
  // Navigate to checkout after 500ms to ensure both events are sent
  setTimeout(() => {
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer');
  }, 500);
};
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 p-3 bg-white/95 backdrop-blur-sm border-t border-border shadow-[0_-4px_20px_rgba(0,0,0,0.05)] z-50 md:hidden" data-id="element-198">
      <div className="max-w-md mx-auto flex flex-col items-center gap-1.5" data-id="element-199">
        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="cta-animate block w-full bg-coral hover:bg-coral-hover text-white font-bold text-base py-3 px-6 rounded-full shadow-md relative overflow-hidden text-center" data-id="element-200">
          <span className="relative z-10" data-id="element-201">Descargar ahora — $6.36</span>
        </a>
        <p className="text-[10px] text-text-secondary font-medium text-center" data-id="element-202">
          Garantía de 7 días · Acceso inmediato
        </p>
      </div>
    </div>;
}